import * as tslib_1 from "tslib";
/**
 * Utility function to create a K:V from a list of strings. Used when creating string-based enums in TypeScript versions
 * prior to 2.4 (see: https://basarat.gitbooks.io/typescript/docs/types/literal-types.html).
 */
export function strEnum(o) {
    return o.reduce(function (res, key) {
        res[key] = key;
        return res;
    }, Object.create(null));
}
/**
 * Base class for extendable errors.
 * @see https://stackoverflow.com/questions/31089801/extending-error-in-javascript-with-es6-syntax
 */
var ApplicationError = /** @class */ (function (_super) {
    tslib_1.__extends(ApplicationError, _super);
    function ApplicationError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, _this.constructor);
        }
        else {
            _this.stack = (new Error(message)).stack;
        }
        return _this;
    }
    return ApplicationError;
}(Error));
export { ApplicationError };
/**
 * Helper method to determine if value is an array.
 */
export var isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
/**
 * Helper method to determine if value is numeric
 * @param val
 * @return {number}
 */
export function isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
/**
 * Returns true if the value is null or undefined
 * @param val Value to check
 * @return {boolean} True if the value is null or undefined
 */
export function isNullOrUndefined(val) {
    return typeof val === 'undefined' || val === null;
}
/**
 * Returns true if the value is a string
 * @param value Value to check
 * @returns {boolean} True if the value is a string
 */
export function isString(value) {
    return typeof value === 'string' || value instanceof String;
}
/**
 * Helper function that tests whether localStorage or sessionStorage is supported and available. This is adapted from
 * the "Feature-detecting localStorage" section on the MDN article for "Using the Web Storage API":
 * https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
 * @param type {string} Storage type (should be either 'localStorage' or 'sessionStorage')
 * @return {boolean} True if the specified storage type is both available and supported.
 */
export function storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return e instanceof DOMException && (
        // everything except Firefox
        e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0;
    }
}
/**
 * Given a number of bytes, returns a human-readable filesize with the appropriate units.
 * @param size {number} Number of bytes
 * @param [fractionDigits] {number} Number of digits after the decimal point (defaults to 2).
 * @returns {string}
 */
export function formatBytes(size, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 2; }
    if (size === 0) {
        return '0 B';
    }
    var e = Math.floor(Math.log(size) / Math.log(1e3));
    return +(size / Math.pow(1e3, e)).toFixed(fractionDigits) + ' ' + ('KMGTPEZY'[e - 1] || '') + 'B';
}
/**
 * Function to replace all instances of a substring within the target string with the replacement value.
 * @param targetString the string to replace values in
 * @param search the search string to be replaced
 * @param replacement the replacement string
 */
export function replaceAll(targetString, search, replacement) {
    return targetString.replace(new RegExp(search, 'g'), replacement);
}
